export default "images/css3-logo.png";